<template>
  <div v-loading="loading">
    <header-img :list="headerList"></header-img>
    <div class="main-block">
      <div class="top-title">本人校验</div>
      <div class="title">本人校验</div>
      <el-form ref="form" label-width="150px" label-position="left" size="mini">
        <el-form-item class="must" label="原件上传">
          <div>
            <div class="sfz-upload">
              <up-load
                class="sfz sfz-1 mr20"
                :isShowbutton="false"
                :isshwoList="true"
                v-model="identityFront"
                @handleSuccess="validCard($event)"
              ></up-load>
              <!-- <up-load
                class="sfz sfz-2"
                :isShowbutton="false"
                :isshwoList="true"
                @handleSuccess="validCard($event, 2)"
                v-model="formData.identityBack"
              ></up-load>-->
            </div>
            <div class="tip">1. 5M以内，JPG/PNG格式的图片 2. 请勿提供虚假证件</div>
          </div>
        </el-form-item>
        <el-form-item label="身份认证" class="must">
          <el-button @click="getFace()">立即校验</el-button>
        </el-form-item>
      </el-form>
      <div class="btn">
        <el-button class="sumbit" @click="saveSumbit()">确定并提交</el-button>
      </div>
    </div>
    <!-- 人脸弹窗 -->
    <el-dialog
      width="60%"
      title="FaceID身份验证"
      :visible.sync="innerVisible"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-row style="text-align:center;">
        <vue-qr :text="QRcode" :size="300"></vue-qr>
        <p>请使用手机扫码验证</p>
      </el-row>
    </el-dialog>
    <!-- 分享弹窗 -->
    <ShareDia :show="shareShow" @dialogClose="shareShow=false" @dialogOpen="shareShow=true" />
  </div>
</template>

<script>
import Dialog from "@/components/Dialog";
import VueQr from "vue-qr";
import HeaderImg from "@/components/HeaderImg";
import ShareDia from "./components/ShareDia";
import publicFun from "@/utils/publicFunction";
import UpLoad from "@/components/Upload";
import { sessionStore } from "@/utils/data-management";
import { tableFilter } from "@/views/property-exchange-center/info-collection/tableFilter";
export default {
  components: {
    Dialog,
    HeaderImg,
    UpLoad,
    ShareDia,
    VueQr
  },
  computed: {
    status() {
      return this.$store.state.infoStatus;
    }
  },
  data() {
    return {
      headerList: [
        { name: "产权流转交易中心", path: "/Home" },
        { name: "补贴申请", path: "/applySubsidy" },
        { name: "代替人校验" }
      ],
      innerVisible: false,
      QRcode: "",
      callbackId: "",
      identityFront: "",
      face: false,
      shareShow: false,
      loading: false
    };
  },
  methods: {
    saveSumbit() {
      if (!this.face) {
        return this.$message.error("请先校验身份认证");
      }
      this.subsidyApply();
    },
    // 校验身份证
    validCard(url) {
      this.loading = true;
      this.$api.user
        .getCardValid({ image: url })
        .then(res => {
          if (res.code == 1000) {
            this.$message.success("校验身份证成功");
          } else {
            this.identityFront = "";
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 代替人人脸
    getFace() {
      if (!this.identityFront) {
        return this.$message.error("请先上传身份证照进行识别");
      }
      let data = {
        callbackId: this.$route.query.id,
        identityFront: this.identityFront
      };
      this.loading = true;
      this.$api.apply
        .subsidyProxyFace(data)
        .then(res => {
          if (res.code === 1000) {
            this.callbackId = res.data.callbackId;
            this.QRcode = res.data.verifyFaceUrl;
            this.innerVisible = true;
            this.checkQRCode();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 人脸校验
    checkQRCode() {
      if (this.callbackId === "") {
        return;
      }
      let data = sessionStore.get("subsidy");
      let params = {
        callbackId: this.callbackId,
        ...data
      };
      this.$api.apply
        .subsidyProxy(params)
        .then(res => {
          if (res.code == 1000) {
            if (res.data.faceVerifyStatus == 1) {
              this.$message.success("FaceId验证成功");
              this.innerVisible = false;
              sessionStore.remove("subsidy");
              this.face = true;
            } else if (res.data.faceVerifyStatus == 2) {
              this.$message.error("FaceId验证失败");
              this.innerVisible = false;
              this.$router.go(-1);
            } else {
              setTimeout(() => {
                this.checkQRCode();
              }, 5000);
            }
          }
        })
        .catch(err => {
          this.innerVisible = false;
          this.$router.go(-1);
        });
    },
    // 人脸成功
    subsidyApply() {
      this.$api.user
        .getFarmersInfo({
          phone: sessionStore.get("userInfo").phone
        })
        .then(res => {
          if (res.code == 1000) {
            tableFilter(res.data, true);
            if (this.status == 2 || this.status == 3) {
              this.shareShow = true;
            } else {
              this.$router.push({ name: "InfoCollection", type: "3" });
            }
          }
        });
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.main-block {
  padding: 35px;
  .title {
    width: 900px;
    line-height: 54px;
    padding-left: 54px;
    margin: 95px auto 0;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #394259;
    background: #f8f9fb;
  }
  .el-form {
    width: 900px;
    padding-left: 50px;
    margin: 20px auto;
    /deep/ .el-form-item {
      .el-input {
        width: 300px;
        input {
          height: 30px;
          background: rgba(255, 255, 255, 1);
          border-radius: 2px;
          border: 1px solid rgba(240, 240, 240, 1);
          padding: 9px 10px;
        }
      }
    }
    .code {
      display: inline-block;
      width: 111px;
      line-height: 27px;
      margin-left: 10px;
      cursor: pointer;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      text-align: center;
      color: #007bff;
      border: 1px solid #007bff;
      border-radius: 2px;
    }
    /deep/ .sfz-upload {
      display: flex;
      .sfz .info-container {
        width: 247px;
        height: 156px;
        background: url("../../../assets/sfz-1.png") no-repeat;
        background-size: 100% 100%;
        border-width: 0;
        div {
          display: none;
        }
      }
      img {
        width: 247px;
        height: 156px;
        border-width: 0;
      }
      .el-link--inner {
        display: none;
      }
    }
    .must /deep/ .el-form-item__label::before {
      content: "*";
      color: #f56c6c;
      margin-right: 5px;
    }
  }
  .btn {
    justify-content: center;
  }
}
</style>